import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import TestsRequests from "services/tests";
import GridContainer from "@jumbo/components/GridContainer";
import { Grid } from "@material-ui/core";

import TestElement from "./TestElement";
import { setCreatedQuiz } from "redux/actions/Tests";
import { Pagination } from "@material-ui/lab";
import { animateScroll as scroll } from "react-scroll";
import { Box } from "@mui/material";

const AllTests = () => {
  const {
    allTests,
    activeQuizId,
    testsCurrentPage,
    testsTotalPage,
  } = useSelector(({ tests }) => tests);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(TestsRequests.getAllTests(1));
    dispatch(setCreatedQuiz({}));
    dispatch(TestsRequests.getActiveQuizId());
  }, []);

  const handleChangePagination = (_, value) => {
    dispatch(TestsRequests.getAllTests(value));
    dispatch(setCreatedQuiz({}));
    dispatch(TestsRequests.getActiveQuizId());
    scroll.scrollToTop();
  };

  return (
    <>
      <GridContainer>
        <Grid item xs={12}>
          {allTests &&
            allTests.map((item) => (
              <TestElement data={item} key={item._id} active={activeQuizId} />
            ))}
        </Grid>
      </GridContainer>
      <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
        <Pagination
          count={testsTotalPage}
          color="primary"
          page={testsCurrentPage}
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default AllTests;
